import { Component } from '@angular/core';

@Component({
    selector: 'oc-bms-client-empty',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss'],
    standalone: false
})
export class EmptyComponent {}
